import gql from 'graphql-tag'

export const findInspectionLeadActivity = gql`
  query findInspectionLeadActivity($idLead: Int!) {
    leadActivity:crm_lead_activity(where: {_and: [{activity_result: {_is_null: true}},{activity_type: {name: {_eq: "inspection"}}},{id_lead:{_eq:$idLead}}]}) {
      id
    }
  }
`
